<template>
  <v-card flat>
    <v-card-title>Add Category</v-card-title>
    <v-card-text>
      <v-form @submit.prevent="submitForm">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="form.name"
              label="Category Name *"
              :error-messages="errors.name"
              @blur="$v.form.name.$touch()"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-select
              v-model="form.type"
              :items="categoryTypes"
              label="Type *"
              :error-messages="errors.type"
              @blur="$v.form.type.$touch()"
              @change="$v.form.type.$touch()"
              outlined
              dense
            ></v-select>
          </v-col>

          <v-col cols="12" md="4">
            <!-- <v-text-field
              v-model="form.tax"
              label="Tax Rate (%)"
              type="number"
              step="0.01"
              min="0"
              max="100"
              :error-messages="errors.tax"
              @blur="$v.form.tax.$touch()"
              outlined
              dense
            ></v-text-field> -->
            <v-select
              v-model="form.tax"
              :items="taxTypes"
              label="Tax *"
              :error-messages="errors.tax"
              @blur="$v.form.tax.$touch()"
              @change="$v.form.tax.$touch()"
              outlined
              dense
            ></v-select>
          </v-col>
        </v-row>

        <v-btn
          type="submit"
          color="primary"
          :loading="loading"
          :disabled="$v.form.$invalid"
        >
          <v-icon left>mdi-plus</v-icon>
          Add Category
        </v-btn>
      </v-form>
    </v-card-text>
    <v-divider class="mx-4"></v-divider>
    <v-card-title>Current Categories</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="currentCategories"
        :search="keyword"
        class="elevation-1"
      >
        <!-- <template v-slot:top>
          <v-text-field
            v-model="keyword"
            label="Search"
            placeholder="Enter keyword to search"
            class="ma-4"
            clearable
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </template> -->

        <template v-slot:[`item.type`]="{ item }">
          <span style="text-transform: capitalize">{{ item.type }}</span>
        </template>
        <template v-slot:[`item.tax`]="{ item }">
          <span style="text-transform: capitalize">{{ item.tax }}</span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import {
  M_OU,
  SAVE_FM_CATEGORY,
  GET_FM_CATEGORIES,
} from "@/store/mutation-list";

export default {
  name: "CategoryForm",

  data() {
    return {
      loading: false,
      form: {
        name: "",
        type: "",
        tax: "",
      },
      categoryTypes: [
        { text: "Income", value: "income" },
        { text: "Expense", value: "expense" },
      ],
      taxTypes: [
        { text: "Claimable", value: "claimable" },
        { text: "Non-claimable", value: "non-claimable" },
      ],
      keyword: "", // the seaching function,
      headers: [
        { text: "Category", value: "category" },
        { text: "Income/ Expense", value: "type" },
        { text: "Tax", value: "tax" },
        // { text: "Action", value: "" },
      ],
    };
  },

  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(100),
      },
      type: {
        required,
      },
      tax: {
        required,
      },
    },
  },

  computed: {
    ...mapGetters({
      currentCategories: `${M_OU}${GET_FM_CATEGORIES}`,
    }),
    errors() {
      const errors = {
        name: [],
        type: [],
        tax: [],
      };

      if (this.$v.form.name.$dirty) {
        !this.$v.form.name.required &&
          errors.name.push("Category name is required.");
        !this.$v.form.name.minLength &&
          errors.name.push("Category name must be at least 2 characters.");
        !this.$v.form.name.maxLength &&
          errors.name.push("Category name must be less than 100 characters.");
      }

      if (this.$v.form.type.$dirty) {
        !this.$v.form.type.required &&
          errors.type.push("Category type is required.");
      }

      if (this.$v.form.tax.$dirty) {
        !this.$v.form.tax.required && errors.tax.push("Tax is required.");
      }

      return errors;
    },
  },

  methods: {
    ...mapActions({
      saveCategory: `${M_OU}${SAVE_FM_CATEGORY}`,
    }),
    async submitForm() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;

      this.saveCategory({
        cat: this.form.name,
        type: this.form.type,
        rate: this.form.tax,
      }).then((res) => {
        //response from store. All complete just need to show to popup message
        if (res == "SUCCESS") {
          this.$fire({
            title: "Success",
            text: "Category recorded successfuly.",
            type: "success",
            timer: 3000,
          }).then((r) => {
            console.log(r.value);
          });
          this.resetForm();
          this.dialog = false;
        } else {
          this.$fire({
            title: "Error",
            text: "Error recording category. Please try again.",
            type: "error",
            allowOutsideClick: false,
            //timer: 3000,
          }).then((r) => {
            console.log(r.value);
          });
        }
      });

      /*
      this.loading = true;

      try {
        // eslint-disable-next-line no-unused-vars
        const response = await axios.post("/api/categories", this.form);

        this.$emit("success", "Category added successfully!");
        this.resetForm();

        // Optionally dispatch to Vuex store
        // this.$store.dispatch('categories/addCategory', response.data)
      } catch (error) {
        console.error("Error adding category:", error);
        this.$emit("error", "Error adding category. Please try again.");
      } finally {
        this.loading = false;
      }
      */
    },

    resetForm() {
      this.form = {
        name: "",
        type: "",
        tax: "",
      };
      this.$v.form.$reset();
    },
  },
};
</script>
